import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';

const routeState = {
  isHeader: false,
  titleName: '',
  isBack: false,
  isMenu: false,
  isLogo: false
};

export const state = {
  isShowPopup: true,
  isLoading: false,
  isOn: true,
  isFocus: false,
  isShowMenu: false,
  modalAlertComponents: [],
  modalComponents: [],
  keywords: [],
  initMovePath: '',
  routeLayout: {
    ...routeState
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
